import { useQuery } from "@tanstack/react-query"
import { useParams } from "react-router-dom"
import GameScreenLayout from "@/components/GameScreenLayout"
import { getAlmanac, getPublicAlmanac } from "@/api/gameApi"

export default function AlmanacPage() {
  const { code } = useParams<{ code?: string }>()
  const isPublic = Boolean(code)

  const q = useQuery({
    queryKey: ["almanac", code ?? "me"],
    queryFn: () => (isPublic ? getPublicAlmanac(code!) : getAlmanac()),
  })

  const data = q.data

  return (
    <GameScreenLayout
      title={isPublic ? "Альманах игрока" : "Альманах стихий"}
      backTo={isPublic ? `/play/player/${code}` : "/play/profile"}
    >
      {q.isLoading ? (
        <p className="text-sm text-guardians-muted">Загрузка…</p>
      ) : data ? (
        <div className="space-y-4">
          <p className="text-sm text-guardians-muted">{data.description}</p>
          <p className="text-guardians-accent">
            {data.stampedSlots}/{data.totalSlots} ({data.progressPercent}%)
          </p>
          <ul className="space-y-3">
            {data.species.map((sp) => (
              <li key={`${sp.element}-${sp.style}`} className="text-sm">
                <p className="font-medium">
                  {sp.elementTitle} · {sp.styleTitle}
                </p>
                <p className="text-xs text-guardians-muted">
                  {sp.unlockedRanks}/{sp.totalRanks} рангов
                </p>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </GameScreenLayout>
  )
}
